import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, ActionModal } from "../../secondary";
import styles from "./createAnnouncement.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { CreateEditAnnouncement } from "./createEditAnnouncement";
import { createAnnouncementAsync } from "../../../app/announcementSlice";
import { SUCCESS_STATUS, ERROR_STATUS } from "../../../constants";
import constants from "../../../constants/constants.json";
import iconSuccess from "../../../static/images/icons-check-success.png";
import iconDanger from "../../../static/images/icon-check-danger.png";

export const CreateAnnouncement = ({ history, modalOpen, modalClose }) => {
  const dispatch = useDispatch();
  /* Use hook form */
  const { reset, register, handleSubmit, control, errors } = useForm({
    mode: "all",
  });
  const [msgModal, setMsgModal] = useState(false);
  const resMsgState = useSelector((state) => state.announcement.resMsgState);

  const onSubmitAnnouncement = (data) => {
    const postData = {
      title: data?.announcementID,
      salesOffice: data?.salesOfficeID,
      description: data?.announcementDescriptionID,
    };
    dispatch(createAnnouncementAsync(postData, history)).then(() => {
      setMsgModal(true);
      reset();
    });
  };
  const resetForm = (e) => {
    e.preventDefault();
    reset();
    setMsgModal(false);
    modalClose();
  };
  const modalCheckClose = () => {
    setMsgModal(false);
    reset();
    modalClose();
  };
  return (
    <>
      {!msgModal && (
        <Modal
          modalOpen={modalOpen}
          modalClose={modalClose}
          heading={constants.announcement.createItem}
          className={"modal_box"}
          modalSize={styles.custom_modal_size}
          reset={reset}
        >
          <CreateEditAnnouncement
            register={register}
            handleSubmit={handleSubmit}
            onSubmit={onSubmitAnnouncement}
            control={control}
            errors={errors}
            handleCancel={resetForm}
            isModal="true"
          />
        </Modal>
      )}
      {msgModal && (
        <Modal modalOpen={modalOpen} modalClose={modalClose}>
          <div className="text-center p-4">
            {resMsgState === SUCCESS_STATUS && (
              <ActionModal
                iconImg={iconSuccess}
                heading={constants.announcement.announcementCreatedMsg}
                buttonText={constants.announcement.close}
                buttonAction={() => modalCheckClose()}
              />
            )}

            {resMsgState === ERROR_STATUS && (
              <ActionModal
                iconImg={iconDanger}
                heading={constants.announcement.announcementNotCreatedMsg}
                buttonText={constants.announcement.close}
                buttonAction={() => modalCheckClose()}
              />
            )}
          </div>
        </Modal>
      )}
    </>
  );
};
